// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import icon16 from './staging-16x16.png'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import icon32 from './staging-32x32.png'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import icon180 from './staging-180x180.png'

export { icon16, icon32, icon180 }
